var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.26667V9.816C1 13.2027 1 14.8965 2.04213 15.9483C3.0832 17 4.75893 17 8.11147 17H9.8896C13.2411 17 14.9168 17 15.9589 15.9483C17 14.8955 17 13.2027 17 9.816V5.26667M1 5.26667H17M1 5.26667L1.76907 3.62613C2.3664 2.35253 2.66507 1.7168 3.2688 1.3584C3.8736 1 4.648 1 6.2 1H11.8C13.3509 1 14.1264 1 14.7312 1.3584C15.336 1.7168 15.6347 2.35253 16.2309 3.62613L17 5.26667M7.4 8.46667H10.6",
    stroke: "#E8C133",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/Product.16cc5bbd7c5358a210781147ad91b43d.svg";
export { ForwardRef as ReactComponent };